export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/poster_design.a77d0d5.svg";